<template>
  <v-card>
    <v-card-title
      class="d-flex justify-space-between align-center px-6 px-lg-10 py-6"
    >
      <h2 class="ma-0 text-bold font-28 primary--text">
        {{
          $vuetify.breakpoint.lgAndUp
            ? "Rent protection & Legal expenses eligibility check"
            : "Eligibility check"
        }}
      </h2>
      <v-btn icon class="btn-close" @click="handleClose">
        <img src="@/assets/icons/ic_close.svg" class="ma-0" />
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text
      :style="`height: ${pslScrollHeight}`"
      class="pl-6 pl-lg-10 pr-1 pr-lg-5 py-6"
    >
      <img
        class="main-img"
        src="@/assets/images/Dialog/EligibilityNotMet/dog_boxer.png"
        alt="dog-look-sad"
      />
      <h2 class="dialog-title text-bold text-center font-28 primary--text">
        Sorry!
      </h2>
      <p class="font-20 primary--text text-center mx-10 mb-0">
        Unfortunately since you don’t meet our eligibility criteria, we are
        unable to offer you rent protection or legal expenses cover.
      </p>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="px-6 px-lg-10 py-6">
      <div class="d-flex flex-column justify-center align-center flex-grow-1">
        <BaseButton
          text="CLOSE"
          rounded
          depressed
          height="60"
          class="font-weight-bold font-20"
          :color="'psorange'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
          @click="handleClose"
        >
        </BaseButton>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton.vue";

export default {
  name: "EligibilityNotMetD2CLandlord",
  components: {
    BaseButton,
  },
  props: {
    pslScrollHeight: {
      type: String,
      default: "auto",
    },
  },
  methods: {
    handleClose() {
      this.$emit("cancel-eligibility-not-met");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-card__title) {
  h2 {
    max-width: 80%;
    word-break: break-word;
  }
}

:deep(.v-card__text) {
  img {
    display: block;
    width: 100%;
    max-width: 338px;
    margin: 0px auto 24px;
  }

  .dialog-title {
    margin-bottom: 23px;
  }
}
</style>
